import { render, staticRenderFns } from "./ColumnGroup.vue?vue&type=template&id=1a2af096&"
import script from "./ColumnGroup.vue?vue&type=script&lang=js&"
export * from "./ColumnGroup.vue?vue&type=script&lang=js&"
import style0 from "./ColumnGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports